// @team Commerce Experience
import flow from 'lodash/flow';
import React from 'react';

import AnnualUpgradePopup from '../../features/Popups/pages/AnnualUpgrade';
import { withApolloContext } from '../../utils/apollo';

const UpgradePage = () => <AnnualUpgradePopup flowType="default" cross />;

const Cmp = flow(withApolloContext({ ssr: true }))(UpgradePage);

Cmp.displayName = 'Popup/Upgrade';

export default Cmp;
